import moment from "moment-timezone";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { getRecoil, resetRecoil, setRecoil } from "recoil-nexus";
import LogController from "../../controller/LogController";
import MessageController from "../../controller/MessageController";
import { adverState } from "../../recoil/adver";
import { alarmState, AlarmType } from "../../recoil/alarm";
import { scheduleState } from "../../recoil/schedule";
import { settingsState } from "../../recoil/settings";
import { ThemeState, ThemeType } from "../../recoil/theme";
import { ClockType } from "./type";

moment.locale("en");

export const useRest = () => {
  const navigate = useNavigate();

  const settings = useRecoilValue(settingsState);
  const kioskMode = settings.view.kioskmode.value === "1";

  const theme = useRecoilValue<ThemeType>(ThemeState);
  const [alarm, setAlarm] = useRecoilState<AlarmType>(alarmState);

  // 알림 설정 on/off
  const [isSet, setIsSet] = useState<boolean>(false);
  const [hour, setHour] = useState<number>(0);
  const [minute, setMinute] = useState<number>(0);

  // 시계에 표기될 현재 시간
  const [currentTime, setCurrentTime] = useState<Date>(new Date());

  const navigateMaster = () => {
    // setTimeout(() => {
    //   document.removeEventListener("message", handleAuth);
    // }, 10000);
    navigate(`/master`);
    setRecoil(adverState, true);
  };

  const openAlarm = () => {
    setIsSet(true);
    setHour((currentTime.getHours() + 8) % 24);
    setMinute(currentTime.getMinutes());
  };
  const saveAlarm = () => {
    const currentTimeTemp = moment(currentTime).clone();
    currentTimeTemp.hour(hour);
    currentTimeTemp.minute(minute);

    setAlarm({
      time: currentTimeTemp.toDate(),
      is_available: true,
      effect: "",
    });
    setIsSet(false);

    LogController.click({
      path: "Home",
      params: "morningCall",
      params2: `${currentTimeTemp.format("HH:mm")} 모닝콜 등록`,
    });
  };

  const deleteAlarm = () => {
    resetRecoil(alarmState);

    LogController.click({
      path: "Home",
      params: "morningCall",
      params2: `모닝콜 등록 취소`,
    });
  };
  const cancelAlarm = () => {
    setIsSet(false);
  };

  const addTime = (type: string) => {
    if (type === "hour") {
      setHour((hour + 1) % 24);
    } else {
      setMinute((minute + 10) % 60);
      if (minute + 10 > 60) setHour((hour + 1) % 24);
    }
  };
  const subtractTime = (type: string) => {
    if (type === "hour") {
      setHour(hour - 1 >= 0 ? hour - 1 : hour + 23);
    } else {
      setMinute(minute - 10 > 0 ? minute - 10 : minute + 50);
      if (minute - 10 < 0) setHour(hour - 1 >= 0 ? hour - 1 : hour + 23);
    }
  };

  const formattedTime: ClockType = useMemo(() => {
    const time = moment(currentTime);
    return {
      formattedHour: time.format("hh"),
      formattedMin: time.format("mm"),
      ampm: time.format("A"),
    };
  }, [currentTime]);

  // 11시에 master화면으로 돌아가는 로직
  useEffect(() => {
    try {
      LogController.navigate({
        path: "Home",
        params: "navigate",
        params2: "화면끄기",
      });
    } catch (err: any) {
      console.log(err);
    }

    const calculateRemainingTime = () => {
      const schedule = getRecoil(scheduleState);

      const calculateTimeDiff = (timeString: string | null): number | null => {
        if (!timeString) return null;

        const targetTime = moment(timeString, "HH:mm:ss");
        const currentTime = moment();
        // currentTime.set({ hour: 9, minute: 55 });

        if (targetTime.isBefore(currentTime, "seconds")) {
          targetTime.add(1, "day");
        }

        return targetTime.diff(currentTime);
      };

      const timeDiffs = [
        calculateTimeDiff(schedule.return_to_main_time_1),
        calculateTimeDiff(schedule.return_to_main_time_2),
      ].filter((diff): diff is number => diff !== null);

      let timeDiff = timeDiffs.length > 0 ? Math.min(...timeDiffs) : null;

      console.log("timeDiff1", timeDiffs, schedule);

      if (timeDiff) {
        /**
         * 1~300초
         */
        const randomNumber = Math.floor(Math.random() * 300) + 1;
        // setTimeout(() => {
        //   navigateMaster();
        //   calculateRemainingTime();
        // }, Math.max(timeDiff, 0));

        console.log("random", timeDiff + randomNumber * 1000, randomNumber);
        timeDiff = Math.max(timeDiff, 0);

        setTimeout(
          () => {
            navigateMaster();
            LogController.event({
              path: "Home",
              params: "timer",
              params2: `주간에 메인 페이지로 자동 이동`,
            });
            // calculateRemainingTime();
          },
          timeDiff === 0 ? 0 : timeDiff + randomNumber * 1000
        );
      }
    };

    calculateRemainingTime();
  }, []);

  useEffect(() => {
    if (kioskMode) {
      setTimeout(() => {
        navigateMaster();
      }, 5000);
    }
  }, [kioskMode]);

  useEffect(() => {
    let clockInterval: any;

    const checkAndStart = () => {
      const current = new Date();
      const seconds = current.getSeconds();

      if (seconds === 0) {
        clockInterval = setInterval(() => {
          setCurrentTime(new Date());
        }, 1000 * 60);
      } else {
        const waitTime = (60 - seconds) * 1000;
        setTimeout(() => {
          setCurrentTime(new Date());
          clockInterval = setInterval(() => {
            setCurrentTime(new Date());
          }, 1000 * 60);
        }, waitTime);
      }
    };

    checkAndStart();

    const checkInterval = setInterval(() => {
      if (new Date().getHours() >= 0 && new Date().getHours() < 7) {
        window.ReactNativeWebView?.postMessage(
          MessageController.getActionData("brightness", { bright: 0.05 })
        );
      } else {
        window.ReactNativeWebView?.postMessage(
          MessageController.getActionData("brightness", { bright: 1 })
        );
      }
    }, 1000 * 60 * 5);

    return () => {
      clearInterval(checkInterval);
      clearInterval(clockInterval);
      window.ReactNativeWebView?.postMessage(
        MessageController.getActionData("brightness", { bright: 1 })
      );
    };
  }, []);

  return {
    kioskMode,
    theme,
    alarm,
    isSet,
    hour,
    minute,
    formattedTime,
    navigateMaster,
    openAlarm,
    saveAlarm,
    deleteAlarm,
    cancelAlarm,
    addTime,
    subtractTime,
  };
};
